//Read More
(function( $ ) {

	"use strict";
	
	// javascript code here. i.e.: $(document).ready( function(){} ); 
 
    $(document).ready(function(e) {
        if($('.careers-detail .career-description').length > 0 ) {
            $('.careers-detail .career-description .read-more').click(function(e) {
                e.preventDefault();
                $(this).parents('.career-description').toggleClass('active');

                if($(this).parents('.career-description').hasClass('active')) {
                    $(this).text('Read Less');
                }else {
                    $(this).text('Read More');
                }
            })
        }
    });
   
})(jQuery);